export const ExecutiveTypes = {
  IExecutiveService: Symbol("IExecutiveService"),
};
